import { ref } from "vue";

const alertBannerVisible = ref(false);
const alertBannerHeight = ref(0);

export function useAlertBanner() {
  const setVisible = (visible: boolean) => {
    alertBannerVisible.value = visible;
  };

  const setHeight = (height: number) => {
    alertBannerHeight.value = height;
  };

  return {
    isVisible: alertBannerVisible,
    height: alertBannerHeight,
    setVisible,
    setHeight,
  };
}
